class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }


  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);

  var clearSearchButton = document.querySelector('[data-clear-search]'); //new
  var searchInput = document.querySelector('input[type="search"]'); //new
  var searchResults = document.querySelector('#predictive-search'); //new

    searchInput.addEventListener('input', function() {
    if (searchInput.value.trim() !== '') {
      clearSearchButton.style.display = 'block'; // Показать кнопку, если поле не пустое
    } else {
      clearSearchButton.style.display = 'none'; // Скрыть кнопку, если поле пустое
    }
  });
  
  clearSearchButton.addEventListener('click', function() {
    searchInput.value = '';
    clearSearchButton.style.display = 'none';
    searchResults.style.display = 'none';
      close();
  });